import { render, staticRenderFns } from "./FirmwareDiagnosticsTable.vue?vue&type=template&id=4b39de38&scoped=true"
import script from "./FirmwareDiagnosticsTable.vue?vue&type=script&lang=js"
export * from "./FirmwareDiagnosticsTable.vue?vue&type=script&lang=js"
import style0 from "./FirmwareDiagnosticsTable.vue?vue&type=style&index=0&id=4b39de38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39de38",
  null
  
)

export default component.exports